import styled from "styled-components";

export const FeatureSection = styled.section`
  padding: 80px 20px;
  background-color: #0b0a0f;
  color: var(--lightText);
  position: relative;
  width: 100%;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 56px 16px;
  }
`;

export const Container = styled.div`
  max-width: var(--maxWidth);
  margin: 0 auto;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 60px;
  display: grid;
  gap: 20px;
  justify-items: center;
  max-width: 820px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
`;

export const HeaderTitle = styled.h2`
  font-size: clamp(2.5rem, 5vw, 3.8rem);
  font-weight: 800;
  background: linear-gradient(135deg, #ffffff 40%, #c084fc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  letter-spacing: 2px;
  line-height: 1.1;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2.2rem;
    letter-spacing: 1px;
  }
`;

export const HeaderSubtitle = styled.h3`
  font-size: 1.15rem;
  color: #db2777;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding: 10px 28px;
  border-radius: 999px;
  background: rgba(219, 39, 119, 0.08);
  box-shadow: inset 0 0 0 1px rgba(219, 39, 119, 0.2);
  display: inline-block;
  margin: 0;
  line-height: 1.4;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 0.85rem;
    padding: 8px 20px;
    letter-spacing: 1px;
  }
`;

export const HeaderDescription = styled.p`
  font-size: var(--fontSmall);
  color: #a7a2b0;
  max-width: 700px;
  margin: 0;
  line-height: 1.8;
  padding: 0 10px;
`;

export const CarouselWrapper = styled.div`
  width: 100%;
  max-width: 520px;
  margin: 0 auto 50px;
  padding: 0 12px;

  .slick-slider {
    border-radius: 28px;
    overflow: hidden;
  }

  .slick-list {
    border-radius: 28px;
    background: #0f0e15;
    border: 1px solid rgba(139, 92, 246, 0.15);
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.45);
  }

  .slick-slide > div {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 560px;
    padding: 0;
  }

  .slick-dots {
    bottom: -36px;

    li button:before {
      color: #a855f7;
      opacity: 0.35;
      font-size: 10px;
    }

    li.slick-active button:before {
      opacity: 1;
      color: #a855f7;
    }
  }

  .slick-prev,
  .slick-next {
    z-index: 2;
    width: 40px;
    height: 40px;

    &:before {
      font-size: 32px;
      color: #a855f7;
      opacity: 0.9;
    }

    &:hover:before {
      opacity: 1;
    }
  }

  .slick-prev {
    left: -8px;
  }

  .slick-next {
    right: -8px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 40px;
    padding: 0 8px;
  }

  @media (max-width: 600px) {
    padding: 0 4px;

    .slick-slide > div {
      min-height: 360px;
      padding: 12px;
    }

    .slick-prev,
    .slick-next {
      width: 36px;
      height: 36px;

      &:before {
        font-size: 26px;
      }
    }

    .slick-prev {
      left: 2px;
    }

    .slick-next {
      right: 2px;
    }

    .slick-dots {
      bottom: -32px;
    }
  }
`;

export const Slide = styled.div`
  outline: none;
`;

export const SlideImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
  object-fit: contain;
  object-position: center;
  border-radius: 16px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-bottom: 60px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

export const AmenityCard = styled.div`
  background: rgba(139, 92, 246, 0.03);
  border: 1px solid rgba(139, 92, 246, 0.1);
  border-radius: 20px;
  padding: 30px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #8b5cf6, #ec4899);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: translateY(-5px);
    background: rgba(139, 92, 246, 0.06);
    border-color: rgba(139, 92, 246, 0.3);
    box-shadow: 0 15px 35px rgba(139, 92, 246, 0.1);

    &::before {
      opacity: 1;
    }
  }

  h3 {
    font-size: 1.25rem;
    color: #c084fc;
    margin: 0 0 12px 0;
    font-weight: 700;
  }

  p {
    font-size: 0.95rem;
    color: #a7a2b0;
    line-height: 1.6;
    margin: 0;
  }
`;

export const StatsSection = styled.div`
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.06), rgba(236, 72, 153, 0.03));
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 24px;
  padding: 40px;
  margin-bottom: 60px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  text-align: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 24px;
    gap: 20px;
  }
`;

export const StatBox = styled.div`
  h4 {
    font-size: 2.2rem;
    font-weight: 800;
    color: #db2777;
    margin: 0 0 8px 0;
    background: linear-gradient(135deg, #a855f7 0%, #ec4899 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  span {
    font-size: 1rem;
    color: #c084fc;
    font-weight: 600;
    display: block;
    margin-bottom: 4px;
  }

  p {
    font-size: 0.88rem;
    color: #a7a2b0;
    margin: 0;
  }
`;

export const GallerySection = styled.div`
  margin-bottom: 60px;
`;

export const SectionTitle = styled.h3`
  font-size: 1.8rem;
  color: #fff;
  text-align: center;
  margin-bottom: 35px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;

  span {
    color: #c084fc;
  }
`;

export const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 10px;
  }
`;

export const GalleryItem = styled.div`
  aspect-ratio: 1;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  &:hover {
    transform: scale(1.03) translateY(-3px);
    border-color: rgba(192, 132, 252, 0.4);
    box-shadow: 0 12px 24px rgba(139, 92, 246, 0.15);

    img {
      transform: scale(1.08);
    }
  }
`;

export const InfoSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  margin-bottom: 40px;

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

export const InfoCard = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 35px;

  h4 {
    font-size: 1.3rem;
    color: #fff;
    margin: 0 0 20px 0;
    font-weight: 700;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    padding-bottom: 12px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    gap: 16px;
  }

  li {
    font-size: 0.95rem;
    color: #a7a2b0;
    line-height: 1.5;
    display: flex;
    align-items: flex-start;
    gap: 12px;

    &::before {
      content: '✔';
      color: #c084fc;
      font-weight: bold;
      flex-shrink: 0;
    }

    strong {
      flex-shrink: 0;
      width: 170px;
    }

    @media (max-width: 600px) {
      display: block;
      padding-left: 24px;
      position: relative;

      &::before {
        position: absolute;
        left: 0;
        top: 2px;
      }

      strong {
        display: inline;
        width: auto;
        margin-right: 6px;
      }
    }
  }
`;

export const ContactCard = styled.div`
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.08) 0%, rgba(236, 72, 153, 0.05) 100%);
  border: 1px solid rgba(139, 92, 246, 0.2);
  border-radius: 20px;
  padding: 35px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  h4 {
    font-size: 1.3rem;
    color: #fff;
    margin: 0 0 8px 0;
    font-weight: 700;
  }

  .details {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .item {
    font-size: 0.95rem;
    color: #d1d5db;
    line-height: 1.5;

    strong {
      color: #c084fc;
    }
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 10px;
`;

export const CallButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 28px;
  background: linear-gradient(135deg, #a855f7 0%, #db2777 100%);
  color: #fff;
  font-weight: 700;
  border-radius: 30px;
  text-decoration: none;
  box-shadow: 0 8px 20px rgba(139, 92, 246, 0.2);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 28px rgba(139, 92, 246, 0.35);
  }
`;

export const MapButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 28px;
  background: transparent;
  color: #fff;
  font-weight: 600;
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: #fff;
  }
`;

/* Lightbox styles */
export const LightboxOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 15, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(10px);
`;

export const LightboxContent = styled.div`
  position: relative;
  max-width: 90vw;
  max-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LightboxImage = styled.img`
  max-width: 100%;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const LightboxClose = styled.button`
  position: absolute;
  top: -50px;
  right: 0;
  background: none;
  border: none;
  color: #fff;
  font-size: 2.5rem;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }

  @media (max-width: 768px) {
    top: -40px;
    right: 10px;
    font-size: 2rem;
  }
`;

export const LightboxNav = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 1010;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: #fff;
  }

  ${({ direction }) => (direction === "prev" ? "left: -70px;" : "right: -70px;")}

  @media (max-width: 1024px) {
    ${({ direction }) => (direction === "prev" ? "left: 10px;" : "right: 10px;")}
    width: 44px;
    height: 44px;
  }
`;

export const OfferBanner = styled.div`
  background: linear-gradient(135deg, rgba(219, 39, 119, 0.12) 0%, rgba(168, 85, 247, 0.08) 100%);
  border: 1px solid rgba(219, 39, 119, 0.25);
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  margin-top: 40px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(219, 39, 119, 0.05) 0%, transparent 60%);
    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding: 30px 20px;
    margin-top: 30px;
  }
`;

export const OfferBadge = styled.span`
  background: linear-gradient(135deg, #db2777 0%, #a855f7 100%);
  color: #fff !important;
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding: 6px 16px;
  border-radius: 999px;
  display: inline-block;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(219, 39, 119, 0.3);
`;

export const OfferTitle = styled.h3`
  font-size: 2.2rem;
  font-weight: 800;
  color: #fff;
  margin: 0 0 10px 0;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export const OfferPrice = styled.div`
  font-size: 3rem;
  font-weight: 900;
  margin: 15px 0;
  background: linear-gradient(135deg, #ffffff 40%, #c084fc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  span {
    font-size: 1.2rem;
    font-weight: 500;
    color: #a7a2b0;
    -webkit-text-fill-color: initial;
    background: none;
  }

  @media (max-width: 768px) {
    font-size: 2.4rem;
  }
`;

export const OfferDescription = styled.p`
  font-size: 1.05rem;
  color: #a7a2b0;
  max-width: 600px;
  margin: 0 auto 30px;
  line-height: 1.6;
`;

export const BookOnlineButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 40px;
  background: linear-gradient(135deg, #db2777 0%, #a855f7 100%);
  color: #fff !important;
  font-weight: 800;
  font-size: 1.1rem;
  border-radius: 30px;
  text-decoration: none;
  box-shadow: 0 10px 25px rgba(219, 39, 119, 0.4);
  transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
  letter-spacing: 0.5px;
  border: 1px solid rgba(255, 255, 255, 0.1);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 35px rgba(219, 39, 119, 0.6);
    background: linear-gradient(135deg, #e11d48 0%, #c084fc 100%);
  }
`;
